
import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/AboutUs.css';
import MainImage from '../assets/aboutUs.png'; 
import Image from '../assets/aboutUs.png'; 

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <div id="about" className="about-container">
      <div className="about-content">
        <div className="about-left">
          <div className="Abimage-container">
            <img src={MainImage} alt={t("aboutUsTitle")} className="abmain-image" />
    
          </div>
        </div>
        <div className="about-right">
          <div className="about-text">
            <h2 className="about-subtitle">{t("aboutUsTitle")}</h2>
            <h1 className="about-title">Kasbah Magic</h1>
            <div className="about-description">
              <p>{t("aboutUsDescription1")}</p>
              <p>{t("aboutUsDescription2")}</p>
              <p>{t("aboutUsDescription3")}</p>
              <p>{t("aboutUsDescription4")}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="stats-container">
        <div className="stat-item">
          <h3>{t("statsExperience")}</h3>
          <p>{t("statsExperienceLabel")}</p>
        </div>
        <div className="stat-item">
          <h3>{t("statsClients")}</h3>
          <p>{t("statsClientsLabel")}</p>
        </div>
        <div className="stat-item">
          <h3>{t("statsAvailability")}</h3>
          <p>{t("statsAvailabilityLabel")}</p>
        </div>
        <div className="stat-item">
          <h3>{t("statsCustomization")}</h3>
          <p>{t("statsCustomizationLabel")}</p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;